import { SectionProps } from '../types';
import { StyledGhostSection } from './style';

const bgImage = 'https://media.appcharge.com/defaults/ghost-section.png';

export const GhostSection: React.FC<SectionProps> = ({
  sectionName,
  image,
  textColor,
}) => (
  <StyledGhostSection textColor={textColor || '#fff'}>
    <img className="section-bg-img" src={bgImage} alt={'bg-img'} />
    <div className="section-container">
      {image && (
        <div className="section-coin">
          <img
            className="image"
            src={image}
            alt={sectionName + `prefix image`}
          />
        </div>
      )}
      <span className="section-name">{sectionName}</span>
    </div>
  </StyledGhostSection>
);
